export default "__VITE_ASSET___j10hsPP__"